import { UserSelfcare } from '../types/user'

export const mapUserSelfcareFromAPI = (apiData: any): UserSelfcare => {
  return {
    commercialOffer: apiData.CommercialOffer?.CommercialDescription ?? '',
    aliasSelfcare: apiData.Multiservice?.AliasSelfcare ?? null,
    channelDescriptions:
      apiData.Multiservice?.CommercialDescriptionByChannel?.ChannelDescriptionList?.map(
        (item: any) => ({
          id: item.ID,
          description: item.CommercialDescription,
        })
      ) ?? [],
    products:
      apiData.ProductList?.map((product: any) => ({
        number: product.Number,
        description: product.TypeSpecification?.CommercialDescription ?? '',
        type: product.TypeSpecification?.ProductType ?? '',
        subType: product.TypeSpecification?.ProductSubType ?? '',
      })) ?? [],
  }
}

export const fetchUserSelfcare = async () => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetSelfcareContext`,
    { credentials: 'include' }
  )
  if (!response.ok) throw new Error('Failed to fetch user selfcare data')
  const json = await response.json()
  return mapUserSelfcareFromAPI(json.Result)
}
